import { createParser, useQueryState } from 'nuqs';
import React, { useTransition } from 'react';

import { FuelTypeList } from '@/services/filters/new-filters.service';

import { isFilterEqual, useClearSearch } from '../../utils';
import { FilterBlockGroup } from '../common/filter-block-group';

export const NewFuelTypeFilter: React.FC<{
  fuelTypes: FuelTypeList;
}> = ({ fuelTypes }) => {
  const [_, startTransition] = useTransition();

  const [queryFuelTypes, setQueryFuelTypes] = useQueryState(
    'fueltype',
    createParser({
      parse: (value) => {
        const selectedNames = value ? value.toLowerCase().split(',') : [];

        return (
          fuelTypes?.map((type) => ({
            ...type,
            isSelected: selectedNames.includes(type.value.toLowerCase()),
          })) || []
        );
      },
      serialize: (value) => {
        return value
          .filter((item) => item.isSelected)
          .map((item) => item.value)
          .join(',');
      },
      eq(a, b) {
        return isFilterEqual(a, b);
      },
    })
      .withDefault(
        fuelTypes?.map((type) => ({ ...type, isSelected: false })) || [],
      )
      .withOptions({
        startTransition,
        shallow: false,
        history: 'replace',
      }),
  );

  const clearSearch = useClearSearch();

  const handleSelect = (filter: (typeof queryFuelTypes)[number]) => {
    clearSearch();

    setQueryFuelTypes(
      queryFuelTypes.map((item) =>
        item.id === filter.id
          ? { ...item, isSelected: !item.isSelected }
          : item,
      ),
    );
  };

  return (
    <FilterBlockGroup
      label="Fuel Type"
      filters={queryFuelTypes}
      onSelect={handleSelect}
    />
  );
};
